import { Component, OnInit,Optional, Inject } from '@angular/core';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA  } from '@angular/material/dialog';
import { statusCodes } from 'ew-common-lib';
import { EwMaTableListService } from '../ew-ma-table-list.service';
import { SelectSessionComponent } from '../select-session/select-session.component';

@Component({
  selector: 'app-event-runing',
  templateUrl: './event-runing.component.html',
  styleUrls: ['./event-runing.component.scss']
})
export class EventRuningComponent implements OnInit {
 sessionData:any;
  constructor(private tableListService: EwMaTableListService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EventRuningComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      this.sessionData = data.sessionData;
    }


  closeDailog(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

  joinExistingSession(url):void{ 
    window.open(url,"_self");
  }

  endExistingAndJoinNewSession(sessionData):void{
    console.log(sessionData);
    const url = new URL(sessionData.sessionLink);
    var sid = url.searchParams.get("sid"), wid = url.searchParams.get("webinar_id"), did = url.searchParams.get("did");
    const model = {
      session_id: sid,
      webinar_id: wid,
      domain_id: did
    };
    console.log(model);
    this.tableListService.endOldAndGoLiveNew(model).subscribe(
      (response: any) => {
        this.dialogRef.close();
        var modal = Object.assign({}, sessionData.new_event);
        this.tableListService.goLive(modal).subscribe(
          (response: any) => {
            if (response.status.code == statusCodes.SUCCESS) {
              switch (response.data.status) {
                case "webinar_already_running":
                  window.location.href = response.data.url;
                  break;
                case "another_webinar_running":
                  console.log(response);
                  // this.showSectionLoader = false;
                  let modelData = {'sessionLink':response.data.url,'event_name':response.data.webinar_name, 'responseData':response.data, 'new_event': sessionData.new_event };
                  const dialogRefRunning = this.dialog.open(EventRuningComponent, {
                    maxWidth: '480px',
                    width:'100%',
                    panelClass: 'runing-event',
                    data: { sessionData: modelData}
                  });
              
                  dialogRefRunning.afterClosed().subscribe((result) => {
                  });
                  break;
                case "session_list":
                  // this.showSectionLoader = false;
                  let sessionListData = {'sessionList':response.data.session,'webinar_id': sessionData.new_event.webinar_id,'domain_id': sessionData.new_event.domain_id,'golive_url':response.data.golive_url};
                  const dialogRef = this.dialog.open(SelectSessionComponent, {
                    maxWidth: '600px',
                    width:'100%',
                    panelClass: 'session-event-select',
                    data: { sessionData: sessionListData}
                  });
              
                  dialogRef.afterClosed().subscribe((result) => {
                  });
                  break;
                default:
                  console.log(response.data.status);
              }
            }
          },
          (error) => {
            console.log('error', error);
            // this.showSectionLoader = false;
          }
        )
      },
      (error) => {
        console.log('error', error);
        // this.showSectionLoader = false;
      }
    )
  }

}
